import { flagState } from '@mail/flags';
import { logger } from '@mail-core/logger';
import { FLAGS_MAP } from 'reactApp/modules/mailFlags/constants';

export const {
    getFlagTime: getAiPhotoGenerationLastAttemptTime,
    getFlagShowCounter: getAiPhotoGenerationAttemptsCounter,
    incrementFlagShowCounter: incrementAiPhotoGenerationAttemptsCounter,
    updateFlag: updateAiPhotoGenerationFlag,
} = flagState<typeof FLAGS_MAP>({
    flagKey: FLAGS_MAP['582'],
    onError: () => {
        logger.error(`Flag not found: ${FLAGS_MAP['582']}`);
    },
});
